import 'bootstrap/dist/css/bootstrap.min.css'
import "./App.css";
import "./common.css"
import "./badges.css"
import "./ManagerSideCSS .css"
import "./Constant.css"



import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes.jsx";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { updatePermission } from './redux/auth/authSlice.js';

function App() {

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state?.auth) || {};

  useEffect(() => {
    if (!user) return;

    if (user.user_type == 1) {

      const ws = new WebSocket(`${process.env.REACT_APP_WEBSOCKET_URL}/permission/${user.id}/`);

      ws.onopen = () => console.log("✅ WebSocket connected");
      ws.onmessage = (event) => {
        try {

          const data = JSON.parse(event.data);
          if (data.permissions) {
            dispatch(updatePermission(data.permissions || {}));
          }
        } catch (err) {
          console.error("WebSocket parse error:", err);
        }
      };
      ws.onclose = () => console.log("❌ WebSocket disconnected");
      ws.onerror = (err) => console.error("WebSocket error:", err);

      return () => ws.close();
    }
  }, [user, dispatch]);

  return (
    <>
      <Router>
        <AppRoutes />
        <ToastContainer closeOnClick pauseOnHover draggable />
      </Router>
    </>
  );
}

export default App;